import React from 'react';
import './Speakers from.css';
import uabnb from "../../img/SF/uabnb.png";
import geekle from "../../img/SF/geekle.png";
import lestdoitukraine from "../../img/SF/lestdoitukraine.png";
import Embassy from "../../img/SF/Embassy.png";
import Friends from "../../img/SF/friends.png";
import iua from "../../img/SF/iua.png";
import uje from "../../img/SF/uje.png";
import { t } from 'i18next';

const SpeakersFrom = (props) => { 
    const state = {
        Speakers_item: [
            {
                img: uabnb,
            },
            {
                img: geekle,
            },
            {
                img: lestdoitukraine,
            },
            {
                img: Embassy,
            },
            {
                img: Friends,
            },
            {
                img: iua,
            },
            {
                img: uje,
            },
            
      ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from_wrap" id='partners'>
            <div className="container">
                <h3 className="speakers_from_title">{t("speakersFrom.title")}</h3>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default SpeakersFrom;